import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventDescription'
})
export class EventDescriptionPipe implements PipeTransform {
  transform(eventKey: string | undefined, translations: Record<string, { translateDescription: string }>): string {
    if (!eventKey || !translations) {
      return '';
    }
    return translations[eventKey]?.translateDescription || '';
  }
}